module.exports = __webpack_public_path__ + "img/icon-fav blue active.ab2c46de.svg";